import { GlobalPickFilesModal } from '@/pages/messages/components/chat/chat-main/components/chat-input-extend/components/files-upload/components/select-files-modal';
import { chatContext, useChatContextValue } from './context';

export interface ChatProviderProps {
  children: ReactNode;
}

export function ChatProvider({ children }: ChatProviderProps) {
  const value = useChatContextValue();

  return (
    <chatContext.Provider value={value}>
      {children}
      <GlobalPickFilesModal></GlobalPickFilesModal>
    </chatContext.Provider>
  );
}
